export default __webpack_public_path__ + "static/media/texp1.c77fed67.png";